<template>
  <a-modal :visible="visibleTaxModal" @ok="save" @cancel="cancel" width="800px" :confirmLoading="pageLoading"
    :maskClosable="false">
    <span slot="title"> <a-icon type="reconciliation" />&nbsp;Tax Deposit Entry</span>
    <a-form :form="formTaxmodal">
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="Tax Date" v-if="modeedit">
            <a-date-picker
              v-decorator="['tax_date', { rules: [{ required: true, message: 'please choose the date!' }], initialValue: tax_date }]"
              placeholder="Select Date" format="DD-MM-YYYY" />
          </a-form-item>
          <a-form-item label="Tax Type">
            <a-select v-decorator="['tax_type', { rules: [{ required: false }], initialValue: tax_type }]" disabled>
              <a-select-option v-for="item in getType_tax" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Tax Deposit">
            <a-select
              v-decorator="['kode_setoran_pajak', { rules: [{ required: true }], initialValue: kode_setoran_pajak }]"
              option-filter-prop="children" :filter-option="filterOption" showSearch>
              <a-select-option v-for="item in getListsetoranpajak" :key="item.value" :value="item.value"
                :text="item.text">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Tax Object" v-if="!(tax_type == 'pph_21' || tax_type == 'ppn')">
            <a-select v-decorator="['objek_pajak', { rules: [{ required: false }], initialValue: objek_pajak }]"
              option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
              <a-select-option v-for="item in getListobjekpajak" :key="item.value" :value="item.value" :text="item.text">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-form-item label="DPP Value">
            <a-input-number class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'dpp_value',
    { rules: [{ required: true, validator: (tax_type && tax_type.toLowerCase() == 'pph_2529' ? checkpiReleaseValue : checkPrice) }], initialValue: dpp_value },
  ]" />
          </a-form-item>
          <a-form-item label="Tax Value">
            <a-input-number class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'value',
    {
      rules: [{
        required: true, validator: (jenis_transaksi && jenis_transaksi.toLowerCase() == 'pi' ? checkPriceTaxValue : (jenis_transaksi && jenis_transaksi.toLowerCase() == 'rilis_pi' && tax_type && tax_type!='pph_2529' ? checkpiReleaseValue: checkPrice))
      }], initialValue: value
    },]" />
          </a-form-item>
          <div :style="this.hideUploadDocTax ? 'display:none' : ''">
            <a-form-item label="File Document Tax">
              <a-upload :fileList="fileList" v-decorator="[
                'file_document_tax',
                { rules: [{ required: false, validator: doc_validation }] },
              ]" :remove="handleRemove" :beforeUpload="beforeUpload">
                <a-button>
                  <a-icon type="upload" />Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </a-col>
      </a-row>
      <div class="container-essential" v-if="modeedit && this.fileList.length > 0">
        <a-row :gutter="12">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Date Document">
              <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                'tgl_document',
                {
                  rules: [{ required: true }],
                  initialValue: tgl_document ? moment(tgl_document) : null,
                },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="Type Document">
              <a-select v-decorator="['type_document', { rules: [{ required: true }], initialValue: type_document }]">
                <a-select-option value="Bukti Potong Pajak">Bukti Potong Pajak</a-select-option>
                <a-select-option value="Dokumen Faktur Pajak">Dokumen Faktur Pajak</a-select-option>
                <a-select-option value="Dokumen STP">Dokumen STP</a-select-option>
                <a-select-option value="Dokumen Id Billing">Dokumen Id Billing</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-form-item label="No Document">
              <a-input
                v-decorator="['no_document', { rules: [{ required: true }], initialValue: no_document }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </div>
    </a-form>
    <template slot="footer">
      <a-button @click="modalbuttonSave" block type="primary" html-type="submit" :loading="pageLoading">Save</a-button>
    </template>
  </a-modal>
</template>

<script>
import GlobalMethod from "@/mixins/GlobalMethod.js";
import message from "@/mixins/HandleMessage";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "TaxDepositEntry",
  mixins: [GlobalMethod, message],
  props: [
    "getType_tax",
    "visibleTaxModal",
    "getListsetoranpajak",
    "getListobjekpajak",
    "file_document_tax",
    "tax_type",
    "kode_setoran_pajak",
    "objek_pajak",
    "id_header",
    "id_dtl",
    "jenis_transaksi",
    "dpp_value",
    "value",
    "file",
    "modeedit",
    "type_document",
    "no_document",
    "tgl_document",
    "hideUploadDocTax",
    "tax_date",
  ],
  data() {
    let doc_validation = (rule, value, callback) => {
      console.log()
      if (this.fileList && this.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      fileList: [],
      pageLoading: false,
    }
  },
  beforeCreate() {
    this.formTaxmodal = this.$form.createForm(this);
  },
  activated() {
    this.fileList = [];
    if (this.file) {
      this.fileList.push(this.file);
    }
  },
  mounted() {
    this.fileList = [];
    if (this.file) {
      this.fileList.push(this.file);
    }
  },
  watch: {
    file() {
      if (this.file) {
        this.fileList = [];
        this.fileList.push(this.file[0]);
      }
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ])
  },
  methods: {
    moment,
    save() {

    },
    cancel() {
      this.fileList = [];
      this.formTaxmodal.resetFields();
      Event.$emit("TaxDepositEntryCancel", null);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Value must greater than zero!");
    },
    checkPriceTaxValue(rule, value, callback) {
      if (value >= 0 && value != null) {
        callback();
        return;
      }
      callback("Value must equal or greater than zero!");
    },
    checkpiReleaseValue(rule, value, callback){
      if (value >= 0 && value != null) {
        callback();
        return;
      }
      callback("Value must equal or greater than zero!");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);

        this.$nextTick(function () {
          this.formTaxmodal.setFieldsValue({
            type_document: null,
            no_document: null,
            tgl_document: null,
          });
        });
        return false;
      }
    },
    handleRemove() {
      this.fileList = [];
    },
    modalbuttonSave() {
      this.formTaxmodal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        data.append("jenis_transaksi", this.jenis_transaksi);
        data.append("id_header", this.id_header);
        data.append("id_dtl", this.id_dtl);
        data.append("kode_setoran_pajak", values.kode_setoran_pajak);
        if (values.objek_pajak)
          data.append("objek_pajak", values.objek_pajak ? values.objek_pajak : null);
        data.append("value", values.value);
        data.append("tlc", this.getAuth.username);
        if (this.fileList.length > 0)
          data.append("file_document_tax", this.fileList[0]);
        data.append("dpp_value", values.dpp_value);

        if (this.modeedit && this.fileList.length > 0) {
          data.append("tgl_document", moment(values.tgl_document).format(this.getStandartFormatDate));
          data.append("type_document", values.type_document);
          data.append("no_document", values.no_document);
        }

        if (this.modeedit)
          data.append("tax_date", moment(values.tax_date).format(this.getStandartFormatDate));

        this.pageLoading = true;
        this.asyncAxiosPost("main/setoran_pajak", "formdata", this.getAuth, data)
          .then((response) => {
            Event.$emit("TaxDepositEntryUpdate", {
              id_dtl: this.id_dtl,
              file_document_tax: response.file_document_tax,
              document_tax: response.document_tax ? response.document_tax : "No File Uploaded",
              document_path: response.document_path,
              objek_pajak: values.objek_pajak,
              kode_setoran_pajak: values.kode_setoran_pajak,
              dpp_value: values.dpp_value,
              tax_value: values.value,
              jenis_transaksi: response.jenis_transaksi,
              tax_date: (values.tax_date ? values.tax_date : null),
            });

            this.displayMessage("success-save");
            this.pageLoading = false;
            this.cancel();
          })
          .catch((err) => {
            console.log(err);
            this.pageLoading = false;
          });
      });
    }
  }
};
</script>

<style lang="less" scoped></style>